import { useLanguage } from "../../../context/LanguageContext";
import { Card, CardContent } from "../../../components/ui/card";
import { Edit3, Eye, Filter, Search, Trash2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import StarRating from "../../../components/StarRating";

export default function AdminAllTeachers() {
  const { language } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      {/* Filter & Update */}
      <div className="flex items-center justify-between flex-wrap gap-4">
        {/* Search */}
        <div className="flex items-center gap-2 flex-1">
          <Card className="rounded-2xl w-full lg:w-1/2 h-11 flex items-center">
            <CardContent className="space-x-2 flex items-center p-0 px-4 flex-1">
              <Search className="size-5" />
              <input
                type="search"
                name="title"
                id="title"
                placeholder="Search here..."
                className="w-full outline-none bg-transparent"
              />
            </CardContent>
          </Card>
          <Filter className="fill-gray-500 text-gray-500" />
        </div>
        {/* Actions */}
        <Button
          size="lg"
          className="w-full lg:w-fit h-11 bg-blue-600 text-white hover:bg-blue-600/80 rounded-xl"
        >
          Save
        </Button>
      </div>
      {/* Table */}
      <table className="w-full text-base overflow-auto">
        <thead className="">
          <tr>
            <th className="py-2 text-xl text-left">Name</th>
            <th className="py-2 text-xl text-left">Subject</th>
            <th className="py-2 text-xl text-left">Comments</th>
            <th className="py-2 text-xl text-left">Rating</th>
            <th className="py-2 text-xl text-left">Controller</th>
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3, 4, 5].map((_, index) => (
            <tr key={index} className="text-muted-foreground">
              {/* Name & Rank */}
              <td className="h-11 flex items-center gap-4 font-bold whitespace-nowrap md:whitespace-normal">
                <Link
                  to={"/admin/teacher-settings"}
                  className="hover:text-blue-600"
                >
                  Professor Mohamed Abdel Hamid
                </Link>
              </td>

              {/* Subject */}
              <td className=" font-medium whitespace-nowrap">
                German language
              </td>

              {/* Comments */}
              <td className=" font-medium whitespace-nowrap">78 comments</td>

              {/* Rating */}
              <td className=" font-medium whitespace-nowrap flex items-center gap-2">
                {index + 1} /5 <StarRating rating={index + 1} />
              </td>

              {/* Controller */}
              <td className=" font-medium whitespace-nowrap space-x-2">
                <Button
                  size="icon"
                  variant="default"
                  className="rounded-xl"
                  onClick={() => navigate("/admin/teacher-settings")}
                >
                  <Eye />
                </Button>
                <Button
                  size="icon"
                  variant="outline"
                  className="rounded-xl"
                  onClick={() => {}}
                >
                  <Edit3 />
                </Button>
                <Button
                  size="icon"
                  variant="destructive"
                  className="rounded-xl"
                  onClick={() => {}}
                >
                  <Trash2 />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
